import { useTranslation } from '@zurich/common/hooks';
import { Typography } from '@zurich/ui/atoms';
import { StepLayout } from '~/components/Steps/StepLayout';

export function SerialNumber() {
  const { t } = useTranslation();

  return (
    <StepLayout
      stepName="serialnumber"
      illustration="/images/vsga/fahrgestell.svg"
      alt={t('vsga:serialNumber.title')}
      cameraButtonText={t('vsga:general.nextButtonPhoto')}
    >
      <Typography variant="body2 regular" color="darkBlue">
        {t('vsga:serialNumber.body')}
      </Typography>
    </StepLayout>
  );
}
